import { render, staticRenderFns } from "./MessageSearchForm.vue?vue&type=template&id=187b80e1&"
import script from "./MessageSearchForm.vue?vue&type=script&lang=js&"
export * from "./MessageSearchForm.vue?vue&type=script&lang=js&"
import style0 from "./MessageSearchForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports